import Backbone from 'backbone'
import _ from 'lodash'
import template from './template-naming-panel.hbs'
import i18n from 'scoreboard/components/i18n'
import TemplateNamingPanelContents from './template-naming-panel-contents'
import config from 'scoreboard/components/config'

/**
 * One of the panels on the template naming form.  Allows the user to specify
 * a prefix and suffix, and shows a preview of what that will look like in the
 * application.
 */
var TemplateNamingPanel = Backbone.View.extend({

	// this.options: see template-naming-panel-contents.js

	className: 'panel template-naming-panel',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.addClass(this.options.section)
		this.$el.empty().append(template(this.context()))

		this.contents = new TemplateNamingPanelContents(this.options)

		this.$('.panel-content').append(this.contents.el)
		this.contents.render()

		return this
	},

	context: function() {
		let heading = this.options.heading
		if (_.isNil(heading)) {
			let key = 'template.paste.suffix.header.' + this.options.section
			// #30037 use "dashboards and strategy maps" if strategy maps enabled
			if (this.options.section == 'dashboards' && config.displayStrategyMaps) {
				key += '.strategyMaps'
			}
			heading = i18n.get(key)
		}
		return _.extend({heading}, this.options)
	},

	// returns the template info (the prefix and suffix)
	info: function() {
		return this.contents.info()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.contents], 'remove')
	}

})

export default TemplateNamingPanel

TemplateNamingPanel.__filename__ = 'templates/template-naming-panel.js'
